"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectModeCountMenu = void 0;
var _react = _interopRequireDefault(require("react"));
var _InlineAlertSelected = require("../inlineAlertSelected/InlineAlertSelected");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SelectModeCountMenu = exports.SelectModeCountMenu = function SelectModeCountMenu(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "select-mode-count-menu"
  }, /*#__PURE__*/_react["default"].createElement(_InlineAlertSelected.InlineAlertSelected, {
    message: "Selected",
    count: props.count,
    isSelected: props.isSelected
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "seperator"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "controls"
  }, props.iconControls));
};
//# sourceMappingURL=selectModeCountMenu.js.map